import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Checkbox,
  I18n,
  Link,
  RadioGroup,
  RadioButton,
  TabsList,
  Tab,
  Button,
  ErrorBlock,
} from 'components';

import OfferPopup from '../../../../components/OfferPopup';
import { OFFER_ACCEPT_TYPES } from '../../constants';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getDefaultState = (props) => ({
  isDirty: false,
  isPopupOpened: false,
  accessLevel: props.xbrOfferAcceptType === OFFER_ACCEPT_TYPES.FREE
    ? OFFER_ACCEPT_TYPES.FREE : OFFER_ACCEPT_TYPES.RESTRICTED,
  fullAccessGuard: props.xbrOfferAcceptType === OFFER_ACCEPT_TYPES.FREE
    ? OFFER_ACCEPT_TYPES.PASS : props.xbrOfferAcceptType,
  isOfferAccepted: props.isAccepted,
});

class MobileAccess extends PureComponent {
  constructor(props) {
    super(props);

    this.state = getDefaultState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.xbrOfferAcceptType !== this.props.xbrOfferAcceptType) {
      this.setState(getDefaultState(props));
    }
  }

  getAcceptType() {
    const {
      accessLevel,
      fullAccessGuard,
    } = this.state;

    if (accessLevel === OFFER_ACCEPT_TYPES.FREE) {
      return accessLevel;
    }

    return fullAccessGuard;
  }

  render() {
    const {
      isPopupOpened,
      accessLevel,
      isOfferAccepted,
      fullAccessGuard,
      isDirty,
    } = this.state;

    const {
      error,
      refreshAction,
      actualVersion,
      offerText,
      saveAccessConfig,
      accessConfigUpdatingStatus,
    } = this.props;

    if (error) {
      return (
        <ErrorBlock
          title={<I18n path="settings.passwordAndAccess.mobileAccessTitle" />}
          refreshAction={refreshAction}
        />
      );
    }

    return (
      <DataBlocks.Block
        title={<I18n path="settings.passwordAndAccess.mobileAccessTitle" />}
        description={<I18n path="settings.passwordAndAccess.mobileAccessDescription" />}
        isLoading={!offerText}
      >
        <RadioGroup
          name={`access-level-${actualVersion}`}
          value={accessLevel}
          onChange={(value) => this.setState({
            isDirty: true,
            accessLevel: value,
          })}
        >
          <RadioButton value={OFFER_ACCEPT_TYPES.FREE}>
            <I18n path="settings.passwordAndAccess.freeAccess" />
          </RadioButton>
          <I18n
            className={cx('accessDescription')}
            path="settings.passwordAndAccess.freeAccessDescription"
          />
          <RadioButton value={OFFER_ACCEPT_TYPES.RESTRICTED}>
            <I18n path="settings.passwordAndAccess.restrictedAccess" />
          </RadioButton>
          <I18n
            className={cx('accessDescription')}
            path="settings.passwordAndAccess.restrictedAccessDescription"
          />
        </RadioGroup>
        {accessLevel === OFFER_ACCEPT_TYPES.RESTRICTED && (
          <div className={cx('fullAccess')}>
            <I18n path="settings.passwordAndAccess.fullAccessTitle" />
            <TabsList
              className={cx('tabList')}
              type="segmented"
              activeTab={fullAccessGuard}
              handleTabClick={(value) => this.setState({
                isDirty: value !== fullAccessGuard || isDirty,
                accessLevel: OFFER_ACCEPT_TYPES.RESTRICTED,
                fullAccessGuard: value,
              })}
            >
              <Tab id={OFFER_ACCEPT_TYPES.PASS}>
                <I18n path="settings.passwordAndAccess.password" />
              </Tab>
              <Tab id={OFFER_ACCEPT_TYPES.CAPTCHA}>
                <I18n path="settings.passwordAndAccess.captcha" />
              </Tab>
            </TabsList>
          </div>
        )}
        <Checkbox
          name={`offer-${actualVersion}`}
          checked={isOfferAccepted}
          handleChange={() => this.setState({
            isDirty: true,
            isOfferAccepted: !isOfferAccepted,
          })}
        >
          <I18n path="settings.passwordAndAccess.acceptOffer" />
          <Link onClick={(e) => {
            e.preventDefault();

            this.setState({
              isPopupOpened: true,
            });
          }}
          >
            <I18n path="settings.passwordAndAccess.xbrOfferConditions" />
          </Link>
        </Checkbox>
        <div className={cx('actions')}>
          <Button
            onClick={() => {
              saveAccessConfig({
                version: actualVersion,
                xbrOfferAcceptType: this.getAcceptType(),
              });
              this.setState({ isDirty: false });
            }}
            disabled={!isOfferAccepted || !isDirty}
            isLoading={accessConfigUpdatingStatus.isUpdating}
          >
            <I18n path="common.save" />
          </Button>
          {isDirty
            && (
            <>
              <I18n
                className={cx('actionsDivider')}
                path="common.or"
              />
              <Link
                className={cx('revertChangesLink')}
                onClick={() => this.setState(getDefaultState(this.props))}
              >
                <I18n path="common.revertChanges" />
              </Link>
            </>
            )}
        </div>
        <OfferPopup
          offerText={offerText}
          isOpened={isPopupOpened}
          onClose={() => this.setState({
            isPopupOpened: false,
          })}
        />
      </DataBlocks.Block>
    );
  }
}

MobileAccess.propTypes = {
  error: PropTypes.string,
  refreshAction: PropTypes.func,
  xbrOfferAcceptType: PropTypes.string,
  actualVersion: PropTypes.number,
  offerText: PropTypes.string,
  saveAccessConfig: PropTypes.func,
  accessConfigUpdatingStatus: PropTypes.object,
};

export default MobileAccess;
